module.exports = __webpack_public_path__ + "img/vidactive.d30554c6.svg";